module.exports = __webpack_public_path__ + "img/yzh5.e1527b3b.jpg";